import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';

export const HEALTH_ASSESSMENT = {
  campaignId: '3qGqihN3EODKU0H9P7YqPK',
  activityId: 'X50FIy5ImBH0dd1KGyxCh',
  activityType: 'healthJourney_toolboxActivity',
} as const;

/**
 * Deeplink path for the Health Assessment toolbox activity.
 * Use this URL on home masonry tiles to retrigger the assessment after completion.
 */
export const getHealthAssessmentToolboxPath = (): string => {
  const healthJourneyPath = getModulePath(LEAGUE_MODULE_NAMES.healthJourney);

  return `${healthJourneyPath}/campaign/${HEALTH_ASSESSMENT.campaignId}/activity/${HEALTH_ASSESSMENT.activityId}/toolbox`;
};

export const HEALTH_ASSESSMENT_PROMPT_DISMISSED_KEY =
  'healthAssessmentPromptDismissed';
